export default __webpack_public_path__ + "static/media/gas.aafa9629.svg";